import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../../../features/langSlice";
import { Icon } from "../../elements/icon";

const SmartFormulaCarousel = ({ images, isProductPage = false }) => {
  const selectedLang = useSelector(selectCurrentLanguage);
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const child = container.children[index];
    if (child) {
      container.scrollTo({
        left: child.offsetLeft - 16, // optional spacing
        behavior: "smooth",
      });
      setActiveIndex(index);
    }
  };

  const scrollByOffset = (dir) => {
    if (!scrollRef.current) return;
    const newIndex = Math.max(
      0,
      Math.min(images.length - 1, activeIndex + dir)
    );
    scrollToIndex(newIndex);
  };

  return (
    <div className="t-relative t-w-full">
      <div className="t-relative t-overflow-hidden">
        <button
          onClick={() => scrollByOffset(-1)}
          className={`t-absolute t-left-0 t-top-1/2 -t-translate-y-1/2 t-z-10 t-rounded-[0_8px_8px_0] t-p-2 t-bg-white t-shadow ${
            activeIndex === 0 ? "t-opacity-50 t-cursor-not-allowed" : ""
          }`}
        >
          <Icon name="chevronLeft" className="t-w-6 t-h-6" />
        </button>

        <div
          ref={scrollRef}
          className="t-flex t-overflow-x-auto t-scroll-smooth hide-scrollbar t-scroll-snap-x t-snap-mandatory t-no-scrollbar"
        >
          {images.map((img, index) => (
            <div
              key={index}
              className={`t-flex-shrink-0 t-w-[75vw] t-scroll-snap-start ${
                isProductPage
                  ? "md:t-max-w-[500px] t-h-full"
                  : "md:t-max-w-[300px]"
              }`}
            >
              <img
                src={selectedLang === "de" ? img.de : img.en}
                alt=""
                className="t-w-full t-object-cover"
              />
            </div>
          ))}
        </div>

        <button
          onClick={() => scrollByOffset(1)}
          className={`t-absolute t-right-0 t-top-1/2 -t-translate-y-1/2 t-z-10 t-p-2 t-bg-white t-shadow t-rounded-[8px_0_0_8px] ${
            activeIndex === images.length - 1
              ? "t-opacity-50 t-cursor-not-allowed"
              : ""
          }`}
        >
          <Icon name="chevronRight" className="t-w-6 t-h-6" />
        </button>
      </div>

      <div className="t-flex t-gap-2 t-mt-4">
        {images.map((img, index) => {
          const isActive = index === activeIndex;
          return (
            <img
              key={index}
              src={selectedLang === "de" ? img.de : img.en}
              alt={`Thumb ${index + 1}`}
              onClick={() => scrollToIndex(index)}
              className={`t-h-12 t-w-12 t-object-cover t-cursor-pointer t-transition-all t-border-2 ${
                isActive
                  ? "t-border-black t-opacity-100"
                  : "t-border-transparent t-opacity-60 hover:t-opacity-100"
              }`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SmartFormulaCarousel;
